import { applyLang } from './translate';

const messageContainer = document.querySelector('#messageContainer');

/**
 * Parse message from allowed or disallowed dataset prop.
 * @param {string} str The string
 */
function parseMessagePolicy(str) {
  return str ? str.split(',').map(x => x.trim()) : [];
}

/**
 * Eval if msg should be displayed by the message element
 * @param {string} msg The msg key
 */
function shouldShow(msg) {
  if (!messageContainer) return false;

  const allowed = parseMessagePolicy(messageContainer.dataset.allowed);
  const disallowed = parseMessagePolicy(messageContainer.dataset.disallowed);

  return !disallowed.some(x => x === msg) && (allowed.length ? allowed.some(x => x === msg) : true);
}

/**
 * Display the "messageContainer" element, mutate container colors to green and
 * apply the translation from `msg`.
 * @param {string} msg The msg key
 */
export function success(msg) {
  if (!shouldShow(msg)) return;

  messageContainer.style.display = 'block';
  messageContainer.classList.add('successMessage');

  applyLang(messageContainer, `successes.${msg}`);
}

/**
 * Display the "messageContainer" element, mutate container colors to red and
 * apply the translation from `msg`.
 * @param {string} msg
 */
export function error(msg) {
  if (!shouldShow(msg)) return;

  messageContainer.style.display = 'block';
  messageContainer.classList.add('errorMessage');

  applyLang(messageContainer, `errors.${msg}`);
}

export function append(msg) {
  messageContainer.innerText += msg;
}
